import React from 'react';
import { Link } from 'react-router-dom';

const CourseMenu = () => {
    return (
        <div>
            <ul className="menu menu-horizontal p-0 grid grid-cols-3 md:grid-cols-4 lg:flex justify-center px-2 z-50">

                <li tabIndex={0}><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>Engineering</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Top Ranked Engineering Colleges</Link>
                            <ul className='menu bg-base-100'>
                                <li><Link to='/'>Top engineering colleges in bangalore</Link></li>
                                <li><Link to='/'>Top engineering colleges in noida and greater noida</Link></li>
                                <li><Link to='/'>Top engineering colleges in punjab</Link></li>
                                <li><Link to='/'>Top engineering colleges in Ghaziabad</Link></li>
                                <li><Link to='/'>Top engineering colleges in lucknow</Link></li>
                                <li><Link to='/'>Top engineering colleges in up</Link></li>
                                <li><Link to='/'>Top engineering colleges in hyderabad</Link></li>
                                <li><Link to='/'>Top engineering colleges in pune</Link></li>
                                <li><Link to='/'>Top engineering colleges in kanpur</Link></li>
                                <li><Link to='/'>Top engineering colleges in odisha</Link></li>
                                <li><Link to='/'>Top engineering colleges in Karnataka</Link></li>
                                <li><Link to='/'>Top engineering colleges in Mumbai</Link></li>
                                <li><Link to='/'>Top engineering colleges in Chennai</Link></li>
                                <li><Link to='/'>Top engineering colleges in Kerala</Link></li>
                                <li><Link to='/'>Top engineering colleges in Delhi</Link></li>
                                <li><Link to='/'>Top engineering colleges in Telangana</Link></li>
                                <li><Link to='/'>Top engineering colleges in West Bengal</Link></li>
                                <li><Link to='/'>Top autonomus colleges</Link></li>
                            </ul>
                        </li>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Engineering Coaching Institutes</Link>
                        <ul className='menu bg-base-100'>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Delhi</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Hyderabad</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Bangalore</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Kolkata</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Vanarasi</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in vijaywada</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in vishakhapatnam</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Karnataka</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Kota</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Kanpur</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Bihar</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Chandigarh</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in West Bengal</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Kerla</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Lucknow</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Punjab</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Chennai</Link></li>
                                <li><Link to='/'>Top IIT-JEE Coaching Institutes in Odisha</Link></li>
                            </ul></li>
                    </ul>
                </li>

                <li tabIndex={0}><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>Medical</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Top Medical Ranked Colleges</Link>
                            <ul className='menu bg-base-100'>
                                <li><Link to='/'>Top Medical colleges in bangalore</Link></li>
                                <li><Link to='/'>Top Medical colleges in noida and greater noida</Link></li>
                                <li><Link to='/'>Top Medical colleges in punjab</Link></li>
                                <li><Link to='/'>Top Medical colleges in Ghaziabad</Link></li>
                                <li><Link to='/'>Top Medical colleges in lucknow</Link></li>
                                <li><Link to='/'>Top Medical colleges in Bihar</Link></li>
                                <li><Link to='/'>Top Medical colleges in hyderabad</Link></li>
                                <li><Link to='/'>Top Medical colleges in pune</Link></li>
                                <li><Link to='/'>Top Medical colleges in kanpur</Link></li>
                                <li><Link to='/'>Top Medical colleges in odisha</Link></li>
                                <li><Link to='/'>Top Medical colleges in Karnataka</Link></li>
                                <li><Link to='/'>Top Medical colleges in Mumbai</Link></li>
                                <li><Link to='/'>Top Medical colleges in Chennai</Link></li>
                                <li><Link to='/'>Top Medical colleges in Kerala</Link></li>
                                <li><Link to='/'>Top Medical colleges in Telangana</Link></li>
                                <li><Link to='/'>Top Medical colleges in Delhi</Link></li>
                                <li><Link to='/'>Top Medical colleges in West Bengal</Link></li>
                                <li><Link to='/'>Top Medical colleges in Chandigarh</Link></li>
                            </ul>
                        </li>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Medical Coaching Institutes</Link>
                        <ul className='menu bg-base-100'>
                                <li><Link to='/'>Top coaching institutes for neet in Gorakhpur</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in delhi</Link></li>
                                <li><Link to='/'>Top NEET Coaching in Lucknow</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Kota</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Noida</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Kanpur</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Varanasi</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Kolkata</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Patna</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Mumbai</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Chennai</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Bangalore</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Kerla</Link></li>
                                <li><Link to='/'>Top coaching institutes for neet in Chandigarh</Link></li>
                            </ul></li>
                    </ul>
                </li>
                

                
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>Pharma</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>Law</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>

                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>MBA</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>B.A</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>CA</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>B.Sc</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>PHD</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>BCA</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
                <li><button className='bg-blue-400 text-white rounded py-2 px-3 my-2 font-semibold mr-2'>UPSC</button>
                    <ul className='menu bg-base-100 text-sm'>
                        <li className='hover-bordered bg-base-100'><Link to='/'>Coming Soon</Link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default CourseMenu;